module.exports = __webpack_public_path__ + "static/media/falling_fruits.1da0d898.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/falling_fruits.png
// module id = 306
// module chunks = 0